import { createIdSlice } from '../utils/action/createElementSlice';
export const StatusState = createIdSlice({
    elementName: 'status',
    initialState: {},
    reducers: {
        set: (_state, action) => {
            return action.payload.data;
        },
        notifyPress: (state) => state,
    },
});
